import "react-toggle/style.css";

import config from "../../app.json";
import axios from "axios";
import AlertComponent from "../AlertComponent";
import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import Toggle from "react-toggle";
import FieldUploadMultipart from "../Fields/FieldUploadMultipart";

function AddOrEditMp4Input(props) {
  const { inputName, handleAddNewElementsInput, currentElement } = props;
  const [s3Path, setS3Path] = useState(null);
  const [customStartingLoop, setCustomStartingLoop] = useState(null);
  const [customStartingLoopError, setCustomStartingLoopError] = useState(null);
  const [useFileOnS3, setUseFileOnS3] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleUseFileOnS3 = () => {
    setUseFileOnS3(!useFileOnS3);
  };

  const handleAddItem = (s3PathApi) => {
    let item = {
      name: inputName,
      s3Path: s3PathApi,
    };

    if (currentElement) {
      item.id = currentElement.id;
    }

    axios
      .post(config.API + "/api/Input/saveInputMP4", item)
      .then((res) => {
        if (res.status === 200 && res.data) {
          const newInput = { ...res.data };
          delete newInput.$id;
          handleAddNewElementsInput(newInput);
          return AlertComponent("Success", "Input has been saved successfully");
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    if (!currentElement) {
      return;
    }
    setUseFileOnS3(true);
    setS3Path(currentElement.s3Path);
  }, [currentElement]);

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    let s3PathApi = s3Path;

    if (!useFileOnS3) {
      s3PathApi = await uploadFile();
    }
    if (s3PathApi) handleAddItem(s3PathApi);
  };

  const uploadFile = async () => {
    if (uploading) {
      return AlertComponent(
        "Error",
        "Your upload is in progress. Please wait it to finish before continue.",
        {
          icon: `error`,
        }
      );
    }

    if (!customStartingLoop) {
      return AlertComponent("Error", "MP4 File is required.", {
        icon: `error`,
      });
    }

    let mp4File = null;
    await axios
      .post(config.API + "/api/file/s3Upload", customStartingLoop)
      .then((res) => {
        mp4File = res.data;
        setS3Path(mp4File);
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });

    return mp4File;
  };

  return (
    <div>
      <Row>
        <Col md={12}>
        <div className="form-group">
          <div className="recurrency mt-4">
            <label>Use file on a s3 folder</label>
            <Toggle
              checked={useFileOnS3}
              onClick={handleUseFileOnS3}
              className="form-group"
            />
          </div>
          <small className="small-info">
            If you already have a file in an s3 folder, past the file path on the
            field below.
          </small>
        </div>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <form onSubmit={onSubmitHandler}>
            <Row>
              <Col md={12}>
                <div className={`${!useFileOnS3 ? "" : "d-none"}`}>
                  <FieldUploadMultipart
                    onUploadComplete={(u) => setCustomStartingLoop(u)}
                    accept={["video/mp4"]}
                    label={"Upload File"}
                    maxSize={4 * 1024 * 1024 * 1024} // 4 GB
                    required={!useFileOnS3}
                    error={customStartingLoopError}
                    onStateChanged={setUploading}
                    className="upload-video-w-progress"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className={`${useFileOnS3 ? "" : "d-none"}`}>
                  <FieldText
                    label="S3 Path"
                    type="text"
                    onChange={(x) => setS3Path(x.target.value)}
                    placeholder="s3://cs-00000000-0000-0000-0000-000000000000/uploads/00000000-0000-0000-0000-000000000000_file.mp4"
                    value={s3Path}
                    required={useFileOnS3}
                    inputClassName={`inputOption`}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="d-flex justify-content-end">
                  <Button className="dark-btn" type="submit">{`${
                    !currentElement ? `Add` : `Update`
                  } Input`}</Button>
                </div>
              </Col>
            </Row>
          </form>
        </Col>
      </Row>
    </div>
  );
}

export default AddOrEditMp4Input;
